export const ODDS_SCREEN_TIME_ZONE = "America/New_York";

const dateKeyFormatter = new Intl.DateTimeFormat("en-US", {
  day: "2-digit",
  month: "2-digit",
  timeZone: ODDS_SCREEN_TIME_ZONE,
  year: "numeric",
});

function toDate(input: string | Date): Date {
  return input instanceof Date ? input : new Date(input);
}

function getPart(parts: Intl.DateTimeFormatPart[], type: Intl.DateTimeFormatPartTypes): string {
  return parts.find((entry) => entry.type === type)?.value ?? "";
}

export function getOddsScreenDateKey(input: string | Date): string {
  const parts = dateKeyFormatter.formatToParts(toDate(input));
  const year = getPart(parts, "year");
  const month = getPart(parts, "month");
  const day = getPart(parts, "day");
  return `${year}-${month}-${day}`;
}
